// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {AssetMetadata} from './asset-metadata.js'
import {Size} from './size.js'

export class ImageAsset {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): ImageAsset {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsImageAsset(bb: flatbuffers.ByteBuffer, obj?: ImageAsset): ImageAsset {
    return (obj || new ImageAsset()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsImageAsset(bb: flatbuffers.ByteBuffer, obj?: ImageAsset): ImageAsset {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new ImageAsset()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  metadata(obj?: AssetMetadata): AssetMetadata | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new AssetMetadata()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  size(obj?: Size): Size | null {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? (obj || new Size()).__init(this.bb_pos + offset, this.bb!) : null
  }

  static startImageAsset(builder: flatbuffers.Builder) {
    builder.startObject(2)
  }

  static addMetadata(builder: flatbuffers.Builder, metadataOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, metadataOffset, 0)
  }

  static addSize(builder: flatbuffers.Builder, sizeOffset: flatbuffers.Offset) {
    builder.addFieldStruct(1, sizeOffset, 0)
  }

  static endImageAsset(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 4) // metadata
    builder.requiredField(offset, 6) // size
    return offset
  }
}
